import moment from 'moment'

import { DiscountField } from './Discounts.interface'

export const filterDiscountsToDays = (array: DiscountField[], day: string) => {
  return array.filter(({ days }) => Number(days) === Number(day))
}

export const filterDiscountsToDate = (array: DiscountField[], day: Date) => {
  return array.filter(
    ({ date }) => formatDate((!!date && date) || new Date()) === formatDate(day)
  )
}

export const formatDate = (date: Date) => {
  return moment(date).format('DD/MM/YYYY')
}

export const extractUuid = (discounts: DiscountField[], array: string[]) => {
  discounts.forEach(({ uuid }) => {
    array.push((!!uuid && uuid) || '')
  })
}

export const handleAddedError = (
  discount: DiscountField,
  name: string,
  message: string
) => {
  return {
    ...discount,
    errors: {
      ...discount.errors,
      [name]: {
        message: message,
        isError: true
      }
    }
  }
}

export const handleRemoveError = (discount: DiscountField, name: string) => {
  return {
    ...discount,
    errors: {
      ...discount.errors,
      [name]: undefined
    }
  }
}

export const days = [
  { label: 'O dia do vencimento', value: 0 },
  { label: '1 dia antes do vencimento', value: 1 },
  { label: '2 dias antes do vencimento', value: 2 },
  { label: '3 dias antes do vencimento', value: 3 },
  { label: '4 dias antes do vencimento', value: 4 },
  { label: '5 dias antes do vencimento', value: 5 },
  { label: '6 dias antes do vencimento', value: 6 },
  { label: '7 dias antes do vencimento', value: 7 },
  { label: '8 dias antes do vencimento', value: 8 },
  { label: '9 dias antes do vencimento', value: 9 },
  { label: '10 dias antes do vencimento', value: 10 },
  { label: '11 dias antes do vencimento', value: 11 },
  { label: '12 dias antes do vencimento', value: 12 },
  { label: '13 dias antes do vencimento', value: 13 },
  { label: '14 dias antes do vencimento', value: 14 },
  { label: '15 dias antes do vencimento', value: 15 },
  { label: '16 dias antes do vencimento', value: 16 },
  { label: '17 dias antes do vencimento', value: 17 },
  { label: '18 dias antes do vencimento', value: 18 },
  { label: '19 dias antes do vencimento', value: 19 },
  { label: '20 dias antes do vencimento', value: 20 },
  { label: '21 dias antes do vencimento', value: 21 },
  { label: '22 dias antes do vencimento', value: 22 },
  { label: '23 dias antes do vencimento', value: 23 },
  { label: '24 dias antes do vencimento', value: 24 },
  { label: '25 dias antes do vencimento', value: 25 },
  { label: '26 dias antes do vencimento', value: 26 },
  { label: '27 dias antes do vencimento', value: 27 },
  { label: '28 dias antes do vencimento', value: 28 },
  { label: '29 dias antes do vencimento', value: 29 },
  { label: '30 dias antes do vencimento', value: 30 }
]

export const daysDueDate = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 }
]

export const expirationOptions = [
  ...Array.from({ length: 59 }, (_, i) => ({
    label: `${60 - i} dias`,
    value: 60 - i
  })),
  { label: '1 dia', value: 1 }
]

export const daysOptions = [
  { label: 'Outro', value: 0 },
  { label: '1 dia', value: 1 },
  ...Array.from({ length: 59 }, (_, i) => ({
    label: `${i + 2} dias`,
    value: i + 2
  }))
]
